import { render, staticRenderFns } from "./BusinessInformationUploadDocForm.vue?vue&type=template&id=0b7043dd"
import script from "./BusinessInformationUploadDocForm.vue?vue&type=script&lang=js"
export * from "./BusinessInformationUploadDocForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports